import { render } from "./SpotKindergartenPatternContainer.vue?vue&type=template&id=252f5b12&ts=true"
import script from "./SpotKindergartenPatternContainer.vue?vue&type=script&lang=ts"
export * from "./SpotKindergartenPatternContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__